import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import Layout from "./Pages/Layout/Layout";
import Dashboard from "./Pages/Dashboard/Dashboard";
import RulesConfiguration from "./Pages/RulesConfiguration/RulesConfiguration";
import Network from "./Pages/Network/Network";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Register";
import FeatureControl from "Pages/FeatureControl/FeatureControl";
import FeatureGate from "./components/FeatureGate";
import PriceList from "./Pages/PriceList/PriceList";
import RulesManagement from "./Pages/RulesManagement/RulesManagement";
import GeneralList from "./Pages/GeneralList/GeneralList";
import ConfigureBenefitGroups from "./Pages/ConfigureBenefitGroups/ConfigureBenefitGroups";
import ConfigureGeneralPolicies from "./Pages/ConfigureGeneralPolicies/ConfigureGeneralPolicies";
import Functional from "./Pages/Functional/Functional";
import FraudDetection from "./Pages/FraudDetection/FraudDetection";
import NotFound from "./Pages/NotFound/NotFound";
import UserConfiguration from "./Pages/UserConfiguration/UserConfiguration";
import ConfigureProviderPolicy from "./Pages/ConfigureProviderPolicy/ConfigureProviderPolicy";
import IcdGrouping from "./Pages/IcdGrouping/IcdGrouping";
import ActivityGrouping from "./Pages/ActivityGrouping/ActivityGrouping";
import DrugsGrouping from "./Pages/DrugsGrouping/DrugsGrouping";
import ActivityToIcdRelation from "./Pages/ActivityToIcdRelation/ActivityToIcdRelation";
import UserManagement from "./Pages/UserManagement/UserManagement";
import Relationicdtoicd from "./Pages/Relationicdtoicd/Relationicdtoicd";
import ConnectToSayan from "./Pages/ConnectToSayan/ConnectToSayan";
import RelationAddAgeAndGender from "./Pages/RelationAddAgeAndGender/RelationAddAgeAndGender";
import ActivityPayerRules from "./Pages/ActivityPayerRules/ActivityPayerRules";
import ActivityToActivityRelation from "./Pages/ActivityToActivityRelation/ActivityToActivityRelation";
import ActivityErrorsRelation from "./Pages/ActivityErrorsRelation/ActivityErrorsRelation";
import NewNetwork from "Pages/NewNetwork/NewNetwork";
import Relationicdpayer from "./Pages/Relationicdpayer/Relationicdpayer";
import Error from "./Pages/Error/Error";
import PatientRelation from "./Pages/PatientRelation/PatientRelation";
import Policy from "./Pages/Policy/Policy";
import ActivityFrequency from "./Pages/ActivityFreq/ActivityFrequency";
import { AuthProvider } from "Pages/PrivateRoute/AuthContext";
import PrivateRoute from "Pages/PrivateRoute/PrivateRoute";
import Test from "./Pages/Test/Test";
import RelationActivityFrequency from "./Pages/RelationActivityFreq/RelationActivityFrequency";
import MedicalIcdGroups from "./Pages/MedicalIcdGroups/MedicalIcdGroups";
import CustomIcdGroups from "./Pages/CustomIcdGroups/CustomIcdGroups";
import UploadFileMedicalIcd from "./Pages/uploadFile/uploadfilemedicalicd/uploadfilemedicalicd";
import MedicalCodes from "./Pages/MedicalCodes/MedicalCodes";
import UploadFileMedicalCodes from "./Pages/uploadFile/uploadfilemedicalcodes/uploadfilemedicalcodes";
import UploadFileCustomIcd from "./Pages/uploadFile/UploadFileCustomGroup/UploadFileCustomGroup";
import ActivityMedicalGroup from "./Pages/ActivityMedicalGroup/ActivityMedicalGroup";
import ActivityCustomGroup from "./Pages/ActivityCustomGroup/ActivityCustomGroup";
import Provider from "./Pages/Provider/Provider";
import BenefitGroup from "Pages/BenefitGroup/BenefitGroup";
import Insurance from "Pages/Insurance/Insurance";
import ICDNotCovered from "Pages/ICDNotCovered/ICDNotCovered";
import PrincipalDiagnosed from "Pages/PrincipalDiagnosed/PrincipalDiagnosed";
import Benefit from "Pages/Benefit/Benefit";
import BenefitTemplate from "Pages/BenefitTemplate/BenefitTemplate";
import IcdAllowed from "Pages/IcdAllowed/IcdAllowed";
import IcdNotAllowed from "Pages/IcdNotAllowed/IcdNotAllowed";
import ActivityCode from "Pages/ActivityCode/ActivityCode";
import ServiceCode from "Pages/ServiceCode/ServiceCode";
import ActivityNotCovered from "Pages/ActivityNotCovered/ActivityNotCovered";
import PerformValidations from "Pages/ClaimValidation/claimValidation";
import ActivityAllowed from "Pages/ActivityAllowed/ActivityAllowed";
import ActivityNotAllowed from "Pages/ActivityNotAllowed/ActivityNotAllowed";
import ActivityNotAllowedICD from "Pages/ActivityNotAllowedICD/ActivityNotAllowedICD";
import ActivityNotAllowedIncludeActivity from "Pages/ActivityNotAllowedIncludeActivity/ActivityNotAllowedIncludeActivity";
import ActivityAgeAndGender from "Pages/ActivityAgeGender/ActivityAgeGender";
import ActivitiesReqirePreApprovals from "Pages/ActivitiesReqirePreApprovals/ActivitiesReqirePreApprovals";
import RefilLimit from "Pages/RefilLimit/RefilLimit";
import QADashboard from "Pages/QADashboard/QADashboard";
import DrugNotCovered from "Pages/DrugNotCovered/DrugNotCovered";
import DrugMedicalGroup from "Pages/DragMedicalGroup/DragMedicalGroup";
import DrugCustomGroups from "Pages/CustomDrugGroups/CustomDrugGroups";
import DragAgeAndGender from "Pages/DragAgeGender/DragAgeGender";
import DrugExclusions from "Pages/DrugExclusions/DrugExclusions";
import DrugNotAllowed from "Pages/DrugsNotAllowedDrugs/DrugsNotAllowedDrugs";
import DrugAllowed from "Pages/DrugAllowedWithDrugs/DrugAllowedWithDrugs";
import SupplyLimit from "Pages/SupplyLimit/SupplyLimit";
import DrugNotAllowedIncludeDrug from "Pages/DragNotAllowedIncludeDrug/DragNotAllowedIncludeDrug";
import DrugsReqirePreApprovals from "Pages/DrugsReqirePreApprovals/DrugsReqirePreApprovals";
import DrugNotAllowedwithActivity from "Pages/DrugNotAllowedwithActivity/DrugNotAllowedwithActivity";
import DrugAllowedwithActivity from "Pages/DrugAllowedwithActivity/DrugAllowedwithActivity";
import DrugNotAllowedwithIcd from "Pages/DrugNotAllowedwithIcd/DrugNotAllowedwithIcd";
import DrugAllowedwithIcd from "Pages/DrugAllowedwithIcd/DrugAllowedwithIcd";
import DrugFrequency from "Pages/DrugFrequancy/DrugFrequancy";
import RefillLimitDrugs from "Pages/RefillLimitDrugs/RefillLimitDrugs";
import Prescriber from "Pages/Prescriber/Prescriber";
import Doctor from "Pages/Doctor/Doctor";
import BulkClaimValidation from "./Pages/ClaimValidation/BulkClaimValidation";
import ValidationHistory from "Pages/ClaimValidation/ValidationHistory";
import ActivityAllowedIcd from "Pages/ActivityAllowedIcd/ActivityAllowedIcd";
import VIP from "Pages/Vip/Vip";
import Specialty from "Pages/Specialty/Specialty";

// ─── Role Protected Route ─────────────────────────────────────────────────────
const RoleProtectedRoute: React.FC<{ allowedRoles: string[]; children: React.ReactNode }> = ({ allowedRoles, children }) => {
  const storedUser = (() => { try { return JSON.parse(localStorage.getItem("user") || "{}"); } catch { return {}; } })();
  const role = storedUser?.role ?? "";
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        { path: "/",        element: <Login />    },
        { path: "register", element: <Register /> },
        { path: "*",        element: <NotFound /> },
        {
          element: <PrivateRoute />,
          children: [
            { path: "dashboard", element: <Dashboard /> },

            // ── Role-protected ────────────────────────────────────────────
            {
              path: "userManagement",
              element: (
                <RoleProtectedRoute allowedRoles={["system_admin", "super_super_admin"]}>
                  <UserManagement />
                </RoleProtectedRoute>
              ),
            },
            {
              path: "featureControl",
              element: (
                <RoleProtectedRoute allowedRoles={["system_admin"]}>
                  <FeatureControl />
                </RoleProtectedRoute>
              ),
            },

            {
  path: "qaDashboard",
  element: (
    <RoleProtectedRoute allowedRoles={["system_admin"]}>
      <QADashboard />
    </RoleProtectedRoute>
  ),
},
            // ── No feature gate needed ────────────────────────────────────
            { path: "pricelist",                  element: <PriceList /> },
            { path: "rulesmanagement",            element: <RulesManagement /> },
            { path: "rulesConfiguration",         element: <RulesConfiguration /> },
            { path: "network",                    element: <Network /> },
            { path: "generallist",                element: <GeneralList /> },
            { path: "configureBenefitGroups",     element: <ConfigureBenefitGroups /> },
            { path: "configureGeneralPolicies",   element: <ConfigureGeneralPolicies /> },
            { path: "configureProviderPolicy",    element: <ConfigureProviderPolicy /> },
            { path: "functional",                 element: <Functional /> },
            { path: "fraudDetection",             element: <FraudDetection /> },
            { path: "userConfiguration",          element: <UserConfiguration /> },
            { path: "IcdGrouping",                element: <IcdGrouping /> },
            { path: "ActivityGrouping",           element: <ActivityGrouping /> },
            { path: "DrugsGrouping",              element: <DrugsGrouping /> },
            { path: "ActTOICD",                   element: <ActivityToIcdRelation /> },
            { path: "Relationicdtoicd",           element: <Relationicdtoicd /> },
            { path: "Relationicdpayer",           element: <Relationicdpayer /> },
            { path: "Error",                      element: <Error /> },
            { path: "PatientRelation",            element: <PatientRelation /> },
            { path: "Policy",                     element: <Policy /> },
            { path: "connectToSayan",             element: <ConnectToSayan /> },
            { path: "ActivityPayerRules",         element: <ActivityPayerRules /> },
            { path: "ActivityToActivityRelation", element: <ActivityToActivityRelation /> },
            { path: "ActivityErrorsRelation",     element: <ActivityErrorsRelation /> },
            { path: "RelationActivityFrequency",  element: <RelationActivityFrequency /> },
            { path: "MedicalIcdGroups",           element: <MedicalIcdGroups /> },
            { path: "CustomIcdGroups",            element: <CustomIcdGroups /> },
            { path: "MedicalCodes",               element: <MedicalCodes /> },
            { path: "UploadFileMedicalCodes",     element: <UploadFileMedicalCodes /> },
            { path: "uploadfilemedicalicd",       element: <UploadFileMedicalIcd /> },
            { path: "UploadFileCustomIcd",        element: <UploadFileCustomIcd /> },
            { path: "ActivityMedicalGroup",       element: <ActivityMedicalGroup /> },
            { path: "ActivityCustomGroup",        element: <ActivityCustomGroup /> },
            { path: "provider",                   element: <Provider /> },
            { path: "NewNetwork",                 element: <NewNetwork /> },
            { path: "Insurance",                  element: <Insurance /> },
            { path: "claimValidation",            element: <PerformValidations /> },
            { path: "benefittemplate",            element: <BenefitTemplate /> },
            { path: "activityCode",               element: <ActivityCode /> },
            { path: "serviceCode",                element: <ServiceCode /> },
            { path: "Test",                       element: <Test /> },
            { path: "activityAgeGender",          element: <ActivityAgeAndGender /> },
            { path: "refilLimit",                 element: <RefilLimit /> },
            { path: "drugNotCovered",             element: <DrugNotCovered /> },
            { path: "drugMedicalGroups",          element: <DrugMedicalGroup /> },
            { path: "drugCustomGroups",           element: <DrugCustomGroups /> },
            { path: "dragAgeGender",              element: <DragAgeAndGender /> },
            { path: "drugExclusions",             element: <DrugExclusions /> },
            { path: "drugNotAllowed",             element: <DrugNotAllowed /> },
            { path: "drugAllowed",                element: <DrugAllowed /> },
            { path: "supplyLimit",                element: <SupplyLimit /> },
            { path: "drugNotAllowedIncludeDrug",  element: <DrugNotAllowedIncludeDrug /> },
            { path: "drugsReqirePreApprovals",    element: <DrugsReqirePreApprovals /> },
            { path: "drugNotAllowedwithActivity", element: <DrugNotAllowedwithActivity /> },
            { path: "drugAllowedwithActivity",    element: <DrugAllowedwithActivity /> },
            { path: "drugNotAllowedwithIcd",      element: <DrugNotAllowedwithIcd /> },
            { path: "drugAllowedwithIcd",         element: <DrugAllowedwithIcd /> },
            { path: "drugFrequency",              element: <DrugFrequency /> },
            { path: "refillLimitDrugs",           element: <RefillLimitDrugs /> },
            { path: "bulkClaimValidation",        element: <BulkClaimValidation /> },
            { path: "validationHistory",          element: <ValidationHistory /> },
            { path: "Prescriber",                 element: <Prescriber /> },
            { path: "doctor",                     element: <Doctor /> },
            { path: "specialty",                  element: <Specialty /> },
            { path: "vip",                        element: <VIP /> },

            // ── Feature-gated routes ──────────────────────────────────────
{ path: "benefitGroup", element: <BenefitGroup /> },
            { path: "benefit",                           element: <FeatureGate featureKey="BENEFIT">                      <Benefit />                           </FeatureGate> },
            { path: "iCDNotCovered",                     element: <FeatureGate featureKey="ICD_NOT_COVERED">              <ICDNotCovered />                     </FeatureGate> },
            { path: "icdAllowed",                        element: <FeatureGate featureKey="ICD_ALLOWED">                  <IcdAllowed />                        </FeatureGate> },
            { path: "icdNotAllowed",                     element: <FeatureGate featureKey="ICD_NOT_ALLOWED">              <IcdNotAllowed />                     </FeatureGate> },
            { path: "RelationAddAgeAndGender",           element: <FeatureGate featureKey="RELATION_AGE_GENDER">          <RelationAddAgeAndGender />           </FeatureGate> },
            { path: "PrincipalDiagnosed",                element: <FeatureGate featureKey="PRINCIPAL_DIAGNOSED">          <PrincipalDiagnosed />                </FeatureGate> },
            { path: "activityNotCovered",                element: <FeatureGate featureKey="ACTIVITY_NOT_COVERED">         <ActivityNotCovered />                </FeatureGate> },
            { path: "activityAllowed",                   element: <FeatureGate featureKey="ACTIVITY_ALLOWED">             <ActivityAllowed />                   </FeatureGate> },
            { path: "activityNotAllowed",                element: <FeatureGate featureKey="ACTIVITY_NOT_ALLOWED">         <ActivityNotAllowed />                </FeatureGate> },
            { path: "ActivityFrequency",                 element: <FeatureGate featureKey="FREQUENCY_CONTROL">            <ActivityFrequency />                 </FeatureGate> },
            { path: "activityAllowedIcd",                element: <FeatureGate featureKey="ACTIVITY_ALLOWED_ICD">         <ActivityAllowedIcd />                </FeatureGate> },
            { path: "activityNotAllowedICD",             element: <FeatureGate featureKey="ACTIVITY_NOT_ICD">             <ActivityNotAllowedICD />             </FeatureGate> },
{ path: "activityBundle", element: <FeatureGate featureKey="ACTIVITY_INCLUDED_ACTIVITY"> <ActivityNotAllowedIncludeActivity /> </FeatureGate> },
            { path: "activitiesReqirePreApprovals",      element: <FeatureGate featureKey="ACTIVITY_PRE_APPROVAL">        <ActivitiesReqirePreApprovals />      </FeatureGate> },

            { path: "*", element: <NotFound /> },
          ],
        },
      ],
    },
  ]);

  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;